import lightTheme from './defaults/light';
import darkTheme from './defaults/dark';
import draculaTheme from './defaults/dracula';

export * from './theme';
export * from './css';
export const light = lightTheme;
export const dark = darkTheme;
export const dracula = draculaTheme;
